module.exports = __webpack_public_path__ + "media/continue-button.3a12e742.svg";